const Salutations = {
    _MALE: "Herr",
    _FEMALE: "Frau",
    _OTHERS: "Divers",
    dropdown: {
        "": "Anrede*",
        Herr: "Herr",
        Frau: "Frau",
        Divers: "Divers",
    }
}

export default Salutations;